'use client';

export default function PrivacyPolicy() {
    return (
        <div className="flex w-full h-full p-2">
            <div className="flex flex-col justify-start items-start w-full h-full p-2">
                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-base md:text-[28px] text-color-base tracking-widest w-full py-8 px-4">
                    プライバシーポリシー
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4">
                    本規約は、株式会社スクーミー（以下「当社」といいます。）は、当社がスクーミー
                    fox.（以下「本サービス」といいます。）を提供するにあたり、ご利用される皆様（以下「利用者」といいます。）の個人に関する情報（以下「個人情報」といいます。）を取得します。
                </div>
                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-sm md:text-base text-color-base tracking-widest w-full pb-2 px-4">
                    第1条（適用範囲）
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4 pl-6">
                    本プライバシーポリシー（以下「本ポリシー」といいます。）は、当社が利用者から個人情報を取得、利用及び管理するときに適用されます。
                </div>
                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-sm md:text-base text-color-base tracking-widest w-full pb-2 px-4">
                    第2条（取得する情報）
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4 pl-6">
                    当社は、利用者から以下の情報を取得します。
                    <ul>
                        <li>(1) メールアドレス</li>
                        <li>(2) 氏名</li>
                        <li>(3) 住所</li>
                        <li>(4) 生年月日</li>
                        <li>(5) 年齢</li>
                        <li>(6) 連絡先</li>
                        <li>(7) クレジットカード情報、銀行口座情報等の決済に関する情報</li>
                        <li>(8) 位置情報</li>
                        <li>(9) 閲覧したURL及び日時に関するタイムスタンプ</li>
                        <li>(10) LINEログイン等の外部認証サービスから提供されるメールアドレスおよびユーザー識別情報</li>
                    </ul>
                </div>
                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-sm md:text-base text-color-base tracking-widest w-full pb-2 px-4">
                    第3条（利用目的）
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4 pl-6">
                    <ul>
                        当社が個人情報を収集・利用する目的は、以下のとおりです。
                        <li>(1) 本サービスの提供・運営のため</li>
                        <li>(2) 本サービスの運営上必要な事項の通知のため</li>
                        <li>(3) 本サービスの会員である利用者の管理のため</li>
                        <li>(4) 本サービスに関する新機能、更新情報をお知らせするため</li>
                        <li>(5) 本サービスその他のコンテンツの開発・改善のため</li>
                        <li>(6) 当社が実施するサービス又は企画に関する連絡のため</li>
                        <li>(7) 上記の利用目的に付随する目的</li>
                        <li>(8) 外部認証サービスによる本人確認およびユーザー管理のため</li>
                    </ul>
                </div>

                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-sm md:text-base text-color-base tracking-widest w-full pb-2 px-4">
                    第4条（Cookieの利用）
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4 pl-6">
                    当社は、ウェブサイト及び本サービス（以下、これらを総称して「ウェブサイト等」といいます。）のアクセス及び利用状況の分析、広告配信並びにウェブサイト等の利便性向上のために、ウェブサイト等にアクセスした利用者の情報通信端末に保存されるCookie等のファイル及びこれに類似する技術を取得することがあります。当社は、Cookie等と利用者の個人情報を関連付けることがあります。当社は、利用者の個人情報と関連付けたCookie等が利用者の個人情報であることに鑑み、当該Cookie等を本ポリシーの定めに従って管理いたします。また、当社は、Cookie等の情報を第三者が運営するデータ・マネジメント・プラットフォームに提供し、当該第三者からCookie等により収集されたウェブの閲覧履歴及びその分析結果を取得し、これらを利用者の個人データと結び付けた上で、広告配信等の目的で利用することがあります。
                </div>
                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-sm md:text-base text-color-base tracking-widest w-full pb-2 px-4">
                    第5条（安全確保の措置）
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4 pl-6">
                    当社は、収集した情報の漏えい、滅失又はき損の防止その他収集した情報の適切な管理のために必要な措置を講じます。当社が、安全管理のために講じた措置の概要は以下のとおりです。措置の具体的内容については、本ポリシーで定める窓口に対する利用者からの求めに応じて遅滞なく回答いたします。
                    <ul>
                        <li>(1) 基本方針の策定、個人情報の取扱いに係る規律の整備</li>
                        <li>(2) 個人情報の取扱責任者や報告連絡体制の整備</li>
                        <li>(3) 定期的な研修の実施</li>
                        <li>(4) 個人情報についての秘密保持に関する誓約を従業者から取得</li>
                        <li>(5) 個人情報についての秘密保持に関する事項を就業規則に記載</li>
                        <li>
                            (6)
                            個人情報を取り扱う機器等の盗難紛失等を防止するための措置（機器の書庫への保管、パスワードの設定等を含む）
                        </li>
                        <li>
                            (7)
                            個人情報を取り扱うことのできる機器やアクセス権者を明確にし、個人情報への不要なアクセスを防止
                        </li>
                    </ul>
                </div>
                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-sm md:text-base text-color-base tracking-widest w-full pb-2 px-4">
                    第6条（個人情報の第三者への提供）
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4">
                    <ol className="list-decimal pl-6">
                        <li>
                            当社は、次に掲げる場合を除いて、あらかじめ利用者の同意を得ないで、取得した個人情報を第三者に提供することはありません。
                            <ul>
                                <li>(1) 法令に基づく場合</li>
                                <li>
                                    (2)
                                    人の生命、身体又は財産の保護のために必要がある場合であって、利用者の同意を得ることが困難であるとき。
                                </li>
                                <li>(3) 本サービスにかかる著作権その他の権利を侵害する行為</li>
                                <li>
                                    (4)
                                    公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、利用者の同意を得ることが困難であるとき。
                                </li>
                                <li>
                                    (5)
                                    国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用者の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき。
                                </li>
                                <li>(6) その他法令で第三者提供の制限の例外が認められている場合</li>
                            </ul>
                        </li>
                        <li>
                            前項の定めにかかわらず、次に掲げる場合には、当該個人情報の提供先は第三者に該当しないものとします。
                            <ul>
                                <li>
                                    (1)
                                    当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託することに伴って当該個人情報が提供される場合
                                </li>
                                <li>(2) 合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
                                <li>(3) 第7条に定める共同利用者に対して提供される場合</li>
                            </ul>
                        </li>
                    </ol>
                </div>
                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-sm md:text-base text-color-base tracking-widest w-full pb-2 px-4">
                    第7条（本プライバシーポリシーの変更）
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4 pl-6">
                    当社は、法令改正への対応の必要性及び事業上の必要性に応じて、本ポリシーを変更する場合があります。本ポリシーの変更を行った場合には、本ウェブサイト上に掲載します。
                </div>
                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-sm md:text-base text-color-base tracking-widest w-full pb-2 px-4">
                    第8条（開示、訂正等の手続）
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4">
                    <ol className="list-decimal pl-6">
                        <li>
                            利用者は、本条及び当社の関連規程に従って、当社に対し、個人情報保護法において認められる限度で、以下の求め又は請求を行うことができます。
                            <ul>
                                <li>(1) 個人情報の利用目的の通知の求め</li>
                                <li>(2) 個人情報又は第三者提供記録の開示の請求</li>
                                <li>(3) 個人情報の訂正、追加又は削除の請求</li>
                                <li>(4) 個人情報の利用の停止の請求</li>
                                <li>(5) 個人情報の第三者への提供の停止の請求</li>
                            </ul>
                        </li>
                        <li>
                            前項の求め又は請求にあたっては、同項各号のうちいずれの請求か特定の上、本人確認のための書類（運転免許証、健康保険証、住民票の写し等）をご提出頂きます。
                        </li>
                    </ol>
                </div>
                <div className="flex flex-shrink-0 justify-start items-end font-corp font-black text-sm md:text-base text-color-base tracking-widest w-full pb-2 px-4">
                    第9条（お問い合わせ）
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-left pb-4 px-4 pl-6">
                    当社の個人情報の取扱いに関するご相談や苦情等のお問い合わせについては、下記の窓口にご連絡ください。
                    <ul>
                        <li>個人情報取扱事業者：株式会社スクーミー</li>
                        <li>代表者名：塩島諒輔</li>
                        <li>住所：山梨県甲府市大手1−2−21　イノベーションベースSoie101</li>
                        <li>Eメールアドレス：go@schoomy.com</li>
                    </ul>
                </div>
                <div className="font-notojp font-medium text-xs md:text-sm text-color-base w-full mx-auto text-right pb-4 px-4">
                    以上
                </div>
            </div>
        </div>
    );
}
